import { ApiService } from "../api";
import { ProjectBudget } from "../projects";

/**
 * Functions for budget related information.
 */
export class ProjectBudgetService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async findById(budgetId: number): Promise<ProjectBudget> {
		const budgetData = await this.apiService.get(
			`/api/v1/project-budget/${budgetId}`,
		);
		const budget = await budgetData.json();
		return ProjectBudget.fromJson(budget);
	}

	public async findBudgetsForAccount(
		accountId: string,
	): Promise<ProjectBudget[]> {
		const budgetData = await this.apiService.get(
			`/api/v1/project-budgets/account/${accountId}`,
		);
		const budgets = await budgetData.json();

		return ProjectBudget.fromJsonArray(budgets);
	}

	public async create(projectBudget: ProjectBudget): Promise<ProjectBudget> {
		const budgetData = await this.apiService.post(
			`/api/v1/accounts/${projectBudget.accountId}/project-budgets`,
			projectBudget,
		);
		const budget = await budgetData.json();
		return ProjectBudget.fromJson(budget);
	}

	public async save(projectBudget: ProjectBudget): Promise<ProjectBudget> {
		const budgetData = await this.apiService.post(
			`/api/v1/project-budget/${projectBudget.id}`,
			projectBudget,
		);

		if (!budgetData.ok) {
			throw new Error(await budgetData.json());
		}

		const budget = await budgetData.json();
		return ProjectBudget.fromJson(budget);
	}

	/**
	 * Create (or replace) the secret link to the client facing hours summary.
	 */
	public async createReportLink(
		budgetId: number,
	): Promise<ProjectBudget> {
		const response = await this.apiService.post(
			`/api/v1/project-budget/${budgetId}/report-link`,
		);

		if (!response.ok) {
			throw new Error(await response.json());
		}

		return ProjectBudget.fromJson(await response.json());
	}

	/**
	 * Revoke the shared link. The existing URL stops working immediately.
	 */
	public async revokeReportLink(budgetId: number): Promise<ProjectBudget> {
		const response = await this.apiService.delete(
			`/api/v1/project-budget/${budgetId}/report-link`,
		);

		return ProjectBudget.fromJson(await response.json());
	}
}
